import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../../res/translations/messages';
import ChoiceType from '../ChoiceType';

const SingleChoice3Type = ({question}) => (
    <>
        <h4><FormattedMessage {...messages.surveys.form.label.optionList} /></h4>
        <ChoiceType choices={question.choices} />
    </>
);

SingleChoice3Type.propTypes = {
    question: PropTypes.object.isRequired,
};


export default SingleChoice3Type;
